import request from "./httpService";
const UPLOAD_ENDPOINT = '/upload';

const upload = (files, onUploadProgress) => {
    return request({
        method: "POST",
        url: `${UPLOAD_ENDPOINT}/new`,
        data: files
    },
    (uploadProgress) => {
        onUploadProgress(uploadProgress)
    });
}
const deleteAttachment = (rowid) => {
    return request({
        method: "DELETE",
        url: `${UPLOAD_ENDPOINT}`,
        params: {rowid: rowid}
    });
}

const getAttachment = (fortable, withid) => {

    return request({
        method: "GET",
        url: `${UPLOAD_ENDPOINT}/${fortable}/${withid}`,
    });
}


export const AttachmentService = {
    upload,
    deleteAttachment,
    getAttachment
};